export const normalizeString = string =>
  string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

export const compareStrings = (first, second) =>
  normalizeString(first).toLowerCase().includes(second.toLowerCase())
